import {
  Button,
  ButtonLink,
  FieldWrapper,
  FileDownloadIcon,
  Stack,
} from '@fukuri-admins/ui/common';
import { useFormContext } from 'react-hook-form';
import { getUsersLink } from '~/utils/getLinks';
import { PaginatedSelect } from '../../../../../src/component/PaginatedSelect';
import type { ApiResponse, OptionType } from '../../../../../src/component/PaginatedSelect/type';

type Props = {
  isButtonDisabled: boolean;
  searchAction: (input: string, page: number) => Promise<ApiResponse>;
  onClientChange: (option: OptionType | null) => void;
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
};

export const DownloadActivationCodesFormPresentation: React.FC<Props> = ({
  isButtonDisabled,
  searchAction,
  onClientChange,
  onSubmit,
}) => {
  const { formState } = useFormContext();
  const clientIdError = formState.errors.clientId;

  return (
    <form onSubmit={onSubmit}>
      <Stack direction='column' gap={24} width='466px'>
        <FieldWrapper
          htmlFor='clientId'
          labelType='required'
          labelText='利用企業'
          errorMessages={clientIdError?.message ? [String(clientIdError.message)] : undefined}
        >
          <PaginatedSelect
            searchAction={searchAction}
            placeholder='選択してください'
            isClearable={true}
            onChange={onClientChange}
          />
        </FieldWrapper>
        <Stack direction='row' gap={16}>
          <ButtonLink to={getUsersLink()} variant='outline' size='md'>
            キャンセル
          </ButtonLink>
          <Button
            type='submit'
            size='md'
            disabled={isButtonDisabled}
            icon={<FileDownloadIcon size='xs' />}
            iconPosition='left'
          >
            CSVダウンロード
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
